import { Provider } from "components/marital-status/MaritalStatusContext";
import { MaritalStatusList } from "components/marital-status/MaritalStatusList";
import React from 'react';

export const MaritalStatuses = () => {
    return (
        <Provider>
            <MaritalStatusList />
        </Provider>
    );
};
